export default {
    data: () => ({
        translations: {
            title: {
                el: "Μέθοδοι Ανταμοιβής",
                en: "Reward Methods",
                it: "Metodi di Ricompensa"
            },
            info: {
                el: "Επιλέξτε τα μέσα για να κερδίζουν πόντοι οι πελάτες σας μέσω των δυνατοτήτων της πλατφόρμας RoadCube. Πολλά χαρακτηριστικά μπορούν να χρησιμοποιηθούν ταυτόχρονα.",
                en: `
                    Select the means for your customers to earn points through the RoadCube platform features. Several features can be used simultaneously.
                `,
                it: "Seleziona i mezzi per i tuoi clienti per guadagnare punti attraverso le funzionalità della piattaforma RoadCube. Diverse funzioni possono essere utilizzate contemporaneamente."
            },
            method: {
                el: "Μέθοδος",
                en: "Method",
                it: "Metodo"
            },
            description: {
                el: "Περιγραφή",
                en: "Description",
                it: "Descrizione"
            },
            activation: {
                el: "Ενεργοποίηση",
                en: "Activation",
                it: "Attivazione"
            },
            settings: {
                el: "Ρυθμίσεις",
                en: "Settings",
                it: "Impostazioni"
            },
            changeSettings: {
                el: "Αλλαγή Ρυθμίσεων",
                en: "Change Settings",
                it: "Cambiare le impostazioni"
            }
        }
    })
};
